module.exports = __webpack_public_path__ + "static/media/doubleCheck.ef7bd5b7.svg";